import { DashboardPanel } from "@components/panels/DashboardPanel"

import { AgentHistoryProvider } from "@plugins/providers/agent/AgentHistoryProvider"

export function DashboardPage() {
    return (
        <AgentHistoryProvider>
            <DashboardPanel />
        </AgentHistoryProvider>
    )
}
